import { HomePage } from './HomePage';
import { connect } from 'react-redux';
import { IReduxRootState } from '../app/reduxRootState.interface';

function mapStateToProps(state: IReduxRootState) {
    const clientConfigEmpty = Object.keys(state.app.clientConfig).length === 0;
    const appConfigEmpty = Object.keys(state.app.appConfig).length === 0;
    const loading = clientConfigEmpty || appConfigEmpty || state.app.redirect;

    return {
        loading,
        presentationConfig: state.app.presentationConfig,
    };
}

const HomePageContainer = connect(mapStateToProps)(HomePage);

export default HomePageContainer;
